import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatError } from "../lib/api";
import { useLanguage } from "../context/LanguageContext";
import { LanguageSwitcher } from "../components/LanguageSwitcher";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";
import { ArrowLeft } from "lucide-react";

export default function ForgotPassword() {
    const { t } = useLanguage();
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [result, setResult] = useState(null);

    const onSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const { data } = await api.post("/auth/forgot-password", { email });
            setResult(data);
            toast.success(t("forgot.success"));
        } catch (err) {
            toast.error(formatError(err.response?.data?.detail) || err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center p-8 relative">
            <div className="absolute top-6 right-6"><LanguageSwitcher /></div>
            <div className="max-w-md w-full space-y-6" data-testid="forgot-password-screen">
                <Link to="/login" className="label-mono flex items-center gap-2 hover:text-primary transition-colors" data-testid="forgot-back-link">
                    <ArrowLeft className="w-3.5 h-3.5" /> {t("forgot.backToLogin")}
                </Link>
                <div>
                    <h1 className="font-heading text-3xl font-semibold">{t("forgot.title")}</h1>
                    <p className="text-muted-foreground mt-2">{t("forgot.subtitle")}</p>
                </div>
                <form onSubmit={onSubmit} className="space-y-4" data-testid="forgot-form">
                    <div className="space-y-2">
                        <Label htmlFor="email">{t("common.email")}</Label>
                        <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                            className="h-12 rounded-md" data-testid="forgot-email-input" />
                    </div>
                    <Button type="submit" disabled={loading}
                        className="w-full h-12 rounded-md bg-primary text-primary-foreground hover:bg-primary/90"
                        data-testid="forgot-submit-button">
                        {loading ? t("forgot.sending") : t("forgot.send")}
                    </Button>
                </form>
            </div>
        </div>
    );
}
